export default __webpack_public_path__ + "static/media/Group 3176@2x.09d235c3.png";